import React from "react";
import { TrendingUp, Home, Sprout } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { SectionHeading } from "../motion/SectionHeading";
import { Stagger, StaggerItem } from "../motion/Reveal";

const ICONS = [TrendingUp, Home, Sprout];
const IMAGES = [
  "https://images.pexels.com/photos/11987205/pexels-photo-11987205.jpeg?auto=compress&w=800",
  "https://images.unsplash.com/photo-1761983721171-bb86a1aeb002?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1473968512647-3e447244af8f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
];

export const Ecosystem = () => {
  const { t } = useLang();
  return (
    <section className="py-10 sm:py-14 bg-white" data-testid="ecosystem-section">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <SectionHeading title={t.ecosystem.title} center />
        <Stagger className="grid grid-cols-3 gap-0 mt-6 sm:mt-10">
          {t.ecosystem.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <StaggerItem key={i}>
                <div
                  className="group relative h-[260px] sm:h-[440px] overflow-hidden hover-zoom cursor-default"
                  data-testid={`ecosystem-card-${i}`}
                >
                  <img src={IMAGES[i]} alt={item.t} className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/40 to-transparent" />
                  <div className="absolute inset-0 p-3 sm:p-8 flex flex-col justify-end">
                    <span className="w-8 h-8 sm:w-12 sm:h-12 rounded-full glass flex items-center justify-center mb-2 sm:mb-5 border border-white/20">
                      <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-gold" />
                    </span>
                    <span className="text-gold text-[10px] sm:text-sm font-medium mb-0.5 sm:mb-1">0{i + 1}</span>
                    <h3 className="font-display text-[15px] sm:text-2xl text-white leading-tight mb-1.5 sm:mb-3">{item.t}</h3>
                    <p className="text-white/75 text-[10px] sm:text-sm leading-snug sm:leading-relaxed max-w-xs line-clamp-4 sm:line-clamp-none">{item.d}</p>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
};
